import React, { useEffect, useState } from "react";
import api from "../api";
import { Heart, MapPin, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Favorites() {
  const [favs, setFavs] = useState([]);
  const [pools, setPools] = useState({});
  const [mns, setMns] = useState({});
  const reload = async () => {
    const { data } = await api.get("/favorites");
    setFavs(data);
    const poolMap = {}, mnsMap = {};
    for (const f of data) {
      if (f.target_type === "pool" && !poolMap[f.target_id]) {
        try { const r = await api.get(`/pools/${f.target_id}`); poolMap[f.target_id] = r.data; }
        catch (e) { console.warn("Favoris: piscine introuvable", f.target_id, e?.response?.status); }
      }
      if (f.target_type === "mns" && !mnsMap[f.target_id]) {
        try { const r = await api.get(`/mns/${f.target_id}`); mnsMap[f.target_id] = r.data; }
        catch (e) { console.warn("Favoris: MNS introuvable", f.target_id, e?.response?.status); }
      }
    }
    setPools(poolMap); setMns(mnsMap);
  };
  useEffect(() => { reload(); }, []);

  const remove = async (f) => {
    await api.delete("/favorites", { params: { target_type: f.target_type, target_id: f.target_id } });
    toast.success("Retiré des favoris"); reload();
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 flex items-center gap-2" style={{ fontFamily: "Outfit" }}>
        <Heart className="w-7 h-7 text-rose-500" /> Mes favoris
      </h1>
      <p className="text-slate-600 mb-6 text-sm">Vous serez alerté lorsqu'un MNS ou une piscine en favori publie de nouveaux créneaux.</p>
      {favs.length === 0 && <div className="card-soft p-8 text-center text-slate-500">Aucun favori. Cliquez sur le cœur depuis une fiche MNS ou piscine.</div>}
      <div className="grid sm:grid-cols-2 gap-3" data-testid="fav-list">
        {favs.map((f) => {
          const t = f.target_type === "pool" ? pools[f.target_id] : mns[f.target_id];
          if (!t) return null;
          const link = f.target_type === "pool" ? `/pool/${f.target_id}` : `/mns/${f.target_id}`;
          const name = f.target_type === "pool" ? t.name : `${t.user?.name}`;
          return (
            <div key={f.favorite_id} className="card-soft p-4 flex items-center justify-between">
              <Link to={link} className="flex-1">
                <div className="font-semibold text-slate-900">{name}</div>
                <div className="text-xs text-slate-500 flex items-center gap-1 mt-1">
                  <MapPin className="w-3 h-3" /> {f.target_type === "pool" ? "Piscine" : "MNS"}
                </div>
              </Link>
              <Button size="icon" variant="ghost" onClick={() => remove(f)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
